import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "card",
  "use": "card-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"card\"><path d=\"M928 160H96a31.949 31.949 0 00-32 32v640c0 17.715 14.336 32 32 32h832c17.715 0 32-14.336 32-32V192a31.949 31.949 0 00-32-32zm-792.013 71.987h752.026V352H135.987V231.987zm752.026 560.077H135.987V440.013h752.026v352zm-237.056-64h165.017c4.404 0 8.039-3.584 8.039-7.987v-72.039a8.038 8.038 0 00-8.039-7.987H651.008a8.038 8.038 0 00-7.987 7.987v71.988c0 4.403 3.584 8.038 7.987 8.038z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol